export default {
  'floorPlan.title': '餐厅平面图',
  'floorPlan.placeholder.section.name': '请输入区域名',
  'floorPlan.placeholder.section.foreign_name': '请输入区域中文名',
  'floorPlan.name.isRequired': '区域名必填',
  'floorPlan.foreign_name.isRequired': '区域中文名必填',
  'floorPlan.description': '如果要设置有多于{maxCount}张桌子的平面图，请先将餐厅分成小区域以便于前端最佳显示',
  'floorPlan.section.title': '区域信息',
  'floorPlan.section.field.name': '区域名',
  'floorPlan.section.field.foreign_name': '区域中文名',
  'floorPlan.section.field.status': '是否可用',
  'floorPlan.shapes.tables': '桌子',
  'floorPlan.shapes.objects': '障碍物',
  'floorPlan.noShapes': '您的平面图上还没有任何图形，先添加一些桌子/障碍物吧',
  'floorPlan.section.notFound.title': '未找到此区域',
  'floorPlan.section.notFound.description': '请检查区域id是否正确或者重试',

  'floorPlan.action.addSection': '创建一个新的区域',
  'floorPlan.action.backToList': '返回区域列表',
  'floorPlan.action.retry': '重试',
  'floorPlan.action.deleteTable': '删除桌子',

  'floorPlan.shape.capacity': '桌子容量',
  'floorPlan.shape.orientation': '朝向',
  'floorPlan.shape.width': '长度',
  'floorPlan.shape.radius': '半径',
  'floorPlan.shape.height': '宽度',
  'floorPlan.shape.status': '是否可用',
  'floorPlan.shape.name': '名称',
  'floorPlan.shape.label': '标签',
  'floorPlan.shape.amount': '数量',
  'floorPlan.shape.setAsOpenTab': '设为Open Tab',
  'floorPlan.shape.setAsOpenTab.description': '开启后可以在此桌子上创建多个订单。',
  'floorPlan.shapes.editTitle': '编辑({count}){shapeName}',

  'floorPlan.section.shape.overlap': '桌子/障碍物间间隔至少为{minGap}个小格。',
  'floorPlan.section.shapes.copied': '已复制! Ctrl/Command + v 键可粘贴',
  'floorPlan.section.saveSuccess': '保存成功',
  'floorPlan.section.shapes.occupied': '抱歉，目前系统不支持对正在使用的桌子进行编辑。',
  'floorPlan.section.shapes.deleteOccupiedShapeError': '抱歉, 目前系统不支持对正在使用的桌子进行删除。',
  'floorPlan.section.shapes.deletionContent': '确认要删除 {shapesText}？',
  'floorPlan.section.exceedMaxCount': '楼层桌子已达到最大数量{maxCount}。',
  'floorPlan.section.existed': '区域名称已被使用。',
  'floorPlan.shape.name.occupied': '桌名已被使用',
  'floorPlan.shape.name.isRequired': '名称必填',
  'floorPlan.shape.capacity.isRequired': '容量必填',
  'floorPlan.shape.capacity.min': '容量必须大于0',
  'floorPlan.shape.label.isRequired': '标签必填',
  'floorPlan.shape.amount.isRequired': '数量必填',
  'floorPlan.shape.amount.min': '数量必须大于0',
  'floorPlan.shape.width.isRequired': '长度必填',
  'floorPlan.shape.width.min': '长度必须大于0',
  'floorPlan.shape.radius.isRequired': '半径必填',
  'floorPlan.shape.radius.min': '半径必须大于0',
  'floorPlan.shape.height.isRequired': '宽度必填',
  'floorPlan.shape.height.min': '宽度必须大于0',
  'floorPlan.shape.name.duplicated': '保存失败。系统检测出重名桌子，请先更正。',
  'floorPlan.deletion.tip': '只能删除不活跃的区域',
  'floorPlan.section.deletionPromptTitle': '删除提示',
  'floorPlan.section.deletionPromptContent': '确认要删除此区域吗？',
  'floorPlan.noProperPosition': '无法找到合适的位置放置图形。',
  'floorPlan.limit': '最小值为{min}，最大值为{max}',
  'floorPlan.openTab.prompt':
    '设置桌子为Open Tab意味着桌子将永远不会变红且可以在这张桌子上创建多个订单。确定要设置桌子为Open Tab吗？',
};
